import type { Template, Software } from './types';

export const mockSoftware: Software[] = [
  { id: 'sw1', name: 'Visual Studio Code', version: '1.85.0', savePath: 'C:\\Program Files\\VSCode', description: '轻量级代码编辑器', category: '开发工具' },
  { id: 'sw2', name: 'Google Chrome', version: '120.0', savePath: 'C:\\Program Files\\Google\\Chrome', description: '网页浏览器', category: '浏览器' },
  { id: 'sw3', name: 'Adobe Photoshop', version: '2024', savePath: 'C:\\Program Files\\Adobe\\Photoshop', description: '图像处理软件', category: '设计工具' },
  { id: 'sw4', name: 'AutoCAD', version: '2024', savePath: 'C:\\Program Files\\Autodesk\\AutoCAD', description: 'CAD设计软件', category: '设计工具' },
  { id: 'sw5', name: 'PyCharm', version: '2023.3', savePath: 'C:\\Program Files\\JetBrains\\PyCharm', description: 'Python IDE', category: '开发工具' },
  { id: 'sw6', name: 'Microsoft Office', version: '2021', savePath: 'C:\\Program Files\\Microsoft Office', description: '办公软件套件', category: '办公软件' },
  { id: 'sw7', name: 'WPS Office', version: '2023', savePath: 'C:\\Program Files\\Kingsoft\\WPS Office', description: '办公软件', category: '办公软件' },
  { id: 'sw8', name: 'Unity', version: '2023.2', savePath: 'C:\\Program Files\\Unity', description: '游戏开发引擎', category: '开发工具' },
  { id: 'sw9', name: 'IntelliJ IDEA', version: '2023.3', savePath: 'C:\\Program Files\\JetBrains\\IntelliJ IDEA', description: 'Java IDE', category: '开发工具' },
  { id: 'sw10', name: 'Blender', version: '4.0', savePath: 'C:\\Program Files\\Blender', description: '3D建模软件', category: '设计工具' },
  { id: 'sw11', name: 'DingTalk', version: '7.0', savePath: 'C:\\Program Files\\DingTalk', description: '钉钉办公软件', category: '办公软件' },
  { id: 'sw12', name: 'WeChat', version: '3.9', savePath: 'C:\\Program Files\\Tencent\\WeChat', description: '微信', category: '通讯工具' },
];

export const mockTemplates: Template[] = [
  {
    id: 'TPL-001',
    name: '开发环境标准版',
    purpose: '软件开发',
    os: 'Windows 11 Pro',
    preInstalledSoftware: [mockSoftware[0], mockSoftware[1], mockSoftware[4]],
    currentVersion: 'v2.1.0',
    status: 'published',
    previousVersion: 'v2.0.5',
    baseImage: 'Windows-11-Pro-Base-2024',
    minConfig: {
      cpuCores: 8,
      memory: 16,
      systemDisk: 256,
      requirePhysical: false,
    },
    sharedDisks: [
      { id: 'disk1', name: '开发工具盘', mountPoint: 'D:', space: 500, owner: '平台' },
    ],
    snapshots: [
      { version: 'v2.1.0', createTime: '2024-01-15 10:30:00', description: '当前版本', changes: ['更新VSCode到1.85.0', '优化系统配置'] },
      { version: 'v2.0.5', createTime: '2023-12-20 14:20:00', description: '稳定版本', changes: ['修复已知问题', '性能优化'] },
      { version: 'v2.0.0', createTime: '2023-11-10 09:15:00', description: '重大更新', changes: ['升级到Windows 11', '新增PyCharm'] },
    ],
  },
  {
    id: 'TPL-002',
    name: '设计工作站专业版',
    purpose: '图形设计',
    os: 'Windows 11 Pro',
    preInstalledSoftware: [mockSoftware[2], mockSoftware[3], mockSoftware[1]],
    currentVersion: 'v1.5.2',
    status: 'published',
    previousVersion: 'v1.5.1',
    baseImage: 'Windows-11-Pro-Base-2024',
    minConfig: {
      cpuCores: 16,
      memory: 32,
      systemDisk: 512,
      requirePhysical: true,
      gpu: {
        models: ['NVIDIA RTX 5070', 'NVIDIA RTX 5090 16G'],
        count: 1,
      },
    },
    sharedDisks: [
      { id: 'disk2', name: '设计素材库', mountPoint: 'D:', space: 1000, owner: '平台' },
      { id: 'disk3', name: '项目文件盘', mountPoint: 'E:', space: 2000, owner: '平台' },
    ],
    snapshots: [
      { version: 'v1.5.2', createTime: '2024-01-10 16:45:00', description: '当前版本', changes: ['更新Photoshop 2024', '优化GPU驱动'] },
      { version: 'v1.5.1', createTime: '2023-12-15 11:30:00', description: '修复版本', changes: ['修复AutoCAD兼容性问题'] },
    ],
  },
  {
    id: 'TPL-003',
    name: 'AI训练环境',
    purpose: '人工智能训练',
    os: 'Ubuntu 22.04 LTS',
    preInstalledSoftware: [mockSoftware[4]],
    currentVersion: 'v3.0.0',
    status: 'published',
    baseImage: 'Ubuntu-22.04-AI-Base',
    minConfig: {
      cpuCores: 32,
      memory: 128,
      systemDisk: 1024,
      requirePhysical: true,
      gpu: {
        models: ['NVIDIA RTX 5090 32G', 'NVIDIA Tesla T4'],
        count: 2,
      },
    },
    sharedDisks: [
      { id: 'disk4', name: '数据集存储', mountPoint: '/data', space: 5000, owner: '平台' },
    ],
    snapshots: [
      { version: 'v3.0.0', createTime: '2024-01-20 09:00:00', description: '当前版本', changes: ['全新AI训练环境', '支持多GPU训练'] },
    ],
  },
  {
    id: 'TPL-004',
    name: '办公标准版',
    purpose: '日常办公',
    os: 'Windows 11 Home',
    preInstalledSoftware: [mockSoftware[1], mockSoftware[6]],
    currentVersion: 'v1.2.0',
    status: 'draft',
    baseImage: 'Windows-11-Home-Base-2024',
    minConfig: {
      cpuCores: 4,
      memory: 8,
      systemDisk: 128,
      requirePhysical: false,
    },
    sharedDisks: [],
    snapshots: [
      { version: 'v1.2.0', createTime: '2024-01-18 14:00:00', description: '草稿版本', changes: ['初始配置'] },
    ],
  },
  {
    id: 'TPL-005',
    name: '游戏开发环境',
    purpose: '游戏开发',
    os: 'Windows 11 Pro',
    preInstalledSoftware: [mockSoftware[0], mockSoftware[7]],
    currentVersion: 'v2.3.1',
    status: 'unpublished',
    previousVersion: 'v2.3.0',
    baseImage: 'Windows-11-Pro-Base-2024',
    minConfig: {
      cpuCores: 16,
      memory: 64,
      systemDisk: 512,
      requirePhysical: true,
      gpu: {
        models: ['NVIDIA RTX 5090 16G'],
        count: 1,
      },
    },
    sharedDisks: [
      { id: 'disk5', name: '游戏资源库', mountPoint: 'D:', space: 3000, owner: '平台' },
    ],
    snapshots: [
      { version: 'v2.3.1', createTime: '2024-01-12 10:20:00', description: '当前版本', changes: ['更新Unity到2023.2'] },
      { version: 'v2.3.0', createTime: '2023-12-05 15:30:00', description: '稳定版本', changes: ['优化游戏开发环境'] },
    ],
  },
];
